import L from 'leaflet';

export const marker = L.icon({
  iconUrl: '/ic-marker.svg',
  iconSize: [24, 24],
  iconAnchor: [22, 24],
  popupAnchor: [-10, -20],
});

export const markerSelected = L.icon({
  iconUrl: '/ic-marker-selected.svg',
  iconSize: [24, 24],
  iconAnchor: [22, 24],
  popupAnchor: [-10, -20],
});

export const pin = L.icon({
  iconUrl: '/ic-flag.svg',
  iconSize: [16, 16],
  iconAnchor: [16, 16],
  popupAnchor: [-10, -20],
});

export const pinSelected = L.icon({
  iconUrl: '/ic-flag-selected.svg',
  iconSize: [16, 16],
  iconAnchor: [16, 16],
  popupAnchor: [-10, -20],
});

export const pinMarked = L.icon({
  iconUrl: '/ic-flag-marked.svg',
  iconSize: [16, 16],
  iconAnchor: [16, 16],
  popupAnchor: [-10, -20],
});



// WEBPACK FOOTER //
// ./src/services/mapIcons.js